"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNext = PageNext;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function PageNext({
  color,
  size = 1,
  variant = 'solid'
}) {
  if (variant === 'solid') {
    return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
      heightAndWidth: size,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
      d: "M22.707 11.295l-9-9A.999.999 0 0012 3.001v3H2a1 1 0 00-1 1v4a1 1 0 00.293.707l6 6a.997.997 0 00.707.293h4v3a1.002 1.002 0 001.707.707l9-9a.998.998 0 000-1.413zM9 16.001l-6-6h6v6z",
      fillColor: color
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
    heightAndWidth: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M22.707 11.294l-9-9A.999.999 0 0012 3.001v3H2a1 1 0 00-1 1v4c0 .265.105.52.293.707l6 6a.996.996 0 00.707.293h4v3a1.002 1.002 0 001.707.707l9-9a.999.999 0 000-1.414zM7 14.587l-2.586-2.586H7v2.586zm7 4v-1.586a1 1 0 00-1-1H9v-5a1 1 0 00-1-1H3v-2h10a1 1 0 001-1V5.416l6.586 6.586L14 18.587z",
    fillColor: color
  }));
}